<template>
  <div class="folders-actions py-8">
    <div>
      <div class="container-fluid">
        <div class="row m-0 flex-no-wrap justify-between items-center">
          <div class="col-auto"></div>
          <div class="col-auto">
            <router-link
              :to="{
                name: 'NewUser',
                params: { tenant: $route.params.tenant },
              }"
              class="dropdown-create-item__placeholder btn-primary"
            >
              <span>Crea nuovo</span>
              <i class="dropdown-create-item__icon icon-checvron_bottom">
                <IconPlus />
              </i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconPlus from '@/assets/icons/icon-plus.svg'
export default {
  components: {
    IconPlus,
  },
}
</script>

<style lang="scss" scoped>
.dropdown-create-item {
  @include btn-primary;
  @apply relative cursor-pointer;
}

.dropdown-create-item__icon {
  @include button-icon-svg;
  @apply ml-4;
}

.dropdown-create-item__options {
  @apply w-full absolute left-0 top-full;
}

.dropdown-create-item__option {
  @apply block w-full border-t border-solid border-white;
}

.dropdown-create-item__option-label {
  @apply block w-full py-4 px-6 bg-blue-500 cursor-pointer;

  &:hover {
    @apply bg-blue-600;
  }
}
</style>
